import styles from './styles.module.scss'
import responsiveStyles from './responsive-styles.module.scss'
import logo from '../../../../../assets/carclaimslogo.png'
import slogo from '../../../../../assets/sentinel-logo.png'
import { Wrapper } from '../../../../reusable'
import { Link } from 'react-router-dom'

export function MailReferralFooter() {
    return (
        <div className={`${styles.footer} ${responsiveStyles.footer}`}>
            <Wrapper>
                <div className={`${styles.innerFooter} ${responsiveStyles.innerFooter}`}>
                    <div className={styles.asteriskInfo}>
                        <p>*£5,318.25 is the average as of 29/05/2024</p>
                        <p>*£10,446.46 is the most significant claim value as of 29/05/2024</p>
                    </div>
                    <div>
                        {/* <h5>Press Releases</h5>
                        <ul className={styles.links}>
                            <li>
                                <a href="https://www.fca.org.uk/news/press-releases/fca-ban-motor-finance-discretionary-commission-models">
                                    https://www.fca.org.uk/news/press-releases/fca-ban-motor-finance-discretionary-commission-models
                                </a>
                            </li>
                            <li>
                                <a href="https://www.fca.org.uk/publication/multi-firm-reviews/our-work-on-motor-finance-final-findings.pdf">
                                    https://www.fca.org.uk/publication/multi-firm-reviews/our-work-on-motor-finance-final-findings.pdf
                                </a>
                            </li>
                        </ul> */}
                        {/* <hr /> */}
                        <div className={styles.footerbottom}>
                            <p style={{ textAlign: 'center' }}>
                                Sentinel legal Limited is Registered in England and Wales. Registered office Harley
                                house, 29 Cambray Place, Cheltenham, England, GL50 1JN. Authorised and regulated by the
                                Solicitors Regulation Authority. SRA number 811792. Company number 12826774. VAT
                                registration number 423 9685 69.
                            </p>
                            <div className={`${styles.terms} ${responsiveStyles.terms}`}>
                                <p>
                                    <a href="https://www.sentinellegal.co.uk/terms-conditions" target="__blank">
                                        Terms and Conditions
                                    </a>
                                </p>
                                <p>
                                    <a href="https://www.sentinellegal.co.uk/privacy-policy" target="__blank">
                                        Privacy Policy
                                    </a>
                                </p>
                                {/* <p>
                                    <a href="../../../../documents/nowinnofee.pdf" target="__blank">
                                        No Win, No Fee Policy
                                    </a>
                                </p> */}
                            </div>
                            <div className={styles.logoContainer}>
                                <p>© {new Date().getFullYear()} Sentinel Legal Ltd.</p>
                                <img src={slogo} />
                            </div>
                        </div>
                    </div>
                </div>
            </Wrapper>
        </div>
    )
}
